import script from "./Programma.vue?vue&type=script&setup=true&lang=js"
export * from "./Programma.vue?vue&type=script&setup=true&lang=js"

import "./Programma.vue?vue&type=style&index=0&id=21b87be7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b87be7"]])

export default __exports__